import React from "react";
import {
  MenuItem,
  FormControl,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import { GrFormClose } from "react-icons/gr";
import {
  SelectLabel,
  SelectMenu,
  StyledMenu,
  StyledMUISelect,
} from "../styled/StyledSelect.styled";

export default function StyledSelect({
  label,
  defaultVal,
  options,
  control,
  setControl,
  helperText,
  disabled,
  isEmptyValAllowed = true,
  ...props
}) {
  const handleChange = (e) => {
    setControl(e.target.value);
  };
  return (
    <div>
      <FormControl variant="standard" sx={{ width: "100%" }}>
        <SelectLabel disableAnimation={true} shrink id={label}>
          {label}
        </SelectLabel>
        {control === "init" ? (
          <StyledMUISelect
            {...props}
            small
            variant="outlined"
            labelId={label}
            id={label}
            renderValue={(selected) => {
              if (selected === "init")
                return <StyledMenu>{defaultVal}</StyledMenu>;
              return <SelectMenu>{selected}</SelectMenu>;
            }}
            sx={{ height: "40px" }}
            onChange={handleChange}
            input={<OutlinedInput />}
            label={label}
            value={control}
            disabled={disabled}
            style={{ marginTop: "30px" }}
          >
            {options && options?.map((option, index) => {
              return (
                <MenuItem
                  sx={{ textTransform: "capitalize" }}
                  key={index}
                  value={option.value || option.label || option}
                  style={{ maxHeight: "300px" }}
                >
                  {option.code && (
                    <img
                      loading="lazy"
                      width="20"
                      src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                      srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}}.png 2x`}
                      alt=""
                      style={{ marginRight: "10px" }}
                    />
                  )}
                  {option.label || option}
                </MenuItem>
              );
            })}
          </StyledMUISelect>
        ) : (<StyledMUISelect
          {...props}
          small
          variant="outlined"
          labelId={label}
          id={label}
          renderValue={(selected) => {
            if (selected === "init")
              return <StyledMenu>{defaultVal}</StyledMenu>;
            return <SelectMenu>{selected}</SelectMenu>;
          }}
          sx={{ height: "40px" }}
          onChange={handleChange}
          input={<OutlinedInput />}
          label={label}
          value={control}
          style={{ marginTop: "30px" }}
          disabled={disabled}
          {...(isEmptyValAllowed && {
            IconComponent: () => {
              return <GrFormClose style={{
                cursor: "pointer",
                position: "absolute",
                right: "7px",
                top: "calc(50% - 0.5em)",
                color: "rgba(0,0,0,0.54)"
              }}
                onClick={() => {
                  if (!disabled) {
                    setControl("init")
                  }
                }} />
            }
          })}
        >
          {options && options?.map((option, index) => {
            return (
              <MenuItem
                sx={{ textTransform: "capitalize" }}
                key={index}
                value={option.value || option.label || option}
                style={{ maxHeight: "300px" }}
              >
                {option.code && (
                  <img
                    loading="lazy"
                    width="20"
                    src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                    srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}}.png 2x`}
                    alt=""
                    style={{ marginRight: "10px" }}
                  />
                )}
                {option.label || option}
              </MenuItem>
            );
          })}
        </StyledMUISelect>)}
        <FormHelperText error>{helperText}</FormHelperText>
      </FormControl>
    </div>
  );
}
